import React from "react";
import { Popper } from "@mui/material";
import { featureDiscoveryTourRegistry } from "./tourRegistry";
import { useFeatureDiscovery } from "./FeatureDiscoveryProvider";
import { FeatureDiscoveryTourModal } from "./FeatureDiscoveryTourModal";
import {
  HelpTooltipBody,
  HelpTooltipBubble,
  HelpTooltipCloseButton,
  HelpTooltipHeader,
  HelpTooltipTitle,
  TourButton,
} from "./FeatureDiscoveryTourModal.styles";

const PROVIDER_HEADER_Z_INDEX = 1300;
const FEATURE_DISCOVERY_TOOLTIP_Z_INDEX = PROVIDER_HEADER_Z_INDEX + 1;

export const FeatureDiscoveryHost = (): React.ReactElement | null => {
  const {
    activeTour,
    closeTour,
    helpAnchor,
    prematureExitTooltipFeatureKey,
    dismissPrematureExitTooltip,
  } = useFeatureDiscovery();
  const activeTourDefinition = activeTour
    ? featureDiscoveryTourRegistry[activeTour.featureKey]
    : null;

  return (
    <>
      {activeTourDefinition && (
        <FeatureDiscoveryTourModal
          tour={activeTourDefinition}
          onClose={closeTour}
        />
      )}
      <Popper
        open={Boolean(prematureExitTooltipFeatureKey && helpAnchor)}
        anchorEl={helpAnchor}
        placement="bottom"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 12],
            },
          },
        ]}
        style={{ zIndex: FEATURE_DISCOVERY_TOOLTIP_Z_INDEX }}
      >
        <HelpTooltipBubble role="dialog" aria-labelledby="feature-help-title">
          <HelpTooltipHeader>
            <HelpTooltipTitle id="feature-help-title">
              Help Center
            </HelpTooltipTitle>
            <HelpTooltipCloseButton
              type="button"
              aria-label="Close Help Center tooltip"
              onClick={dismissPrematureExitTooltip}
            >
              ×
            </HelpTooltipCloseButton>
          </HelpTooltipHeader>
          <HelpTooltipBody>
            Accidentally exited the tour too early? You can always find the
            feature tours and other resources here!
          </HelpTooltipBody>
          <TourButton
            type="button"
            $variant="primary"
            onClick={dismissPrematureExitTooltip}
          >
            Got it
          </TourButton>
        </HelpTooltipBubble>
      </Popper>
    </>
  );
};
